import { ReactNode, useEffect, useMemo, useReducer } from 'react'

import { InferenceMessageContext } from './context'
import { createInferenceMessageActions, inferenceMessageReducer, initialInferenceMessageState } from './messageStore'

export function InferenceProvider({ children, resetKey }: { children: ReactNode; resetKey?: unknown }) {
  const [state, dispatch] = useReducer(inferenceMessageReducer, initialInferenceMessageState)
  const actions = useMemo(() => createInferenceMessageActions(dispatch), [])
  const value = useMemo(() => ({ ...state, ...actions }), [actions, state])

  useEffect(() => {
    if (resetKey !== undefined) {
      dispatch({ type: 'resetMessages' })
    }
  }, [resetKey])

  return <InferenceMessageContext.Provider value={value}>{children}</InferenceMessageContext.Provider>
}
